import React from "react";
import './CSS/Pricing.css';
import {Link} from "react-router-dom";

const Pricing: React.FC = () => {
    return (
        <div className="pricing-container">
            <h1 className="pricing-title">Choose the Plan That Fits Your Team’s Needs</h1>
            <p className="pricing-description">
                Affordable, flexible plans designed to help you foster belonging at scale.
            </p>

            <div className="pricing-plans">
                <div className="pricing-plan trial">
                    <h3>Free Trial</h3>
                    <p className="price">Cancel Anytime</p>
                    <ul className="features">
                        <li><span className="checkmark"></span>Real Time Term Checking</li>
                        <li><span className="checkmark"></span>Tone Analysis</li>
                        <li><span className="checkmark"></span>Single User</li>
                    </ul>
                </div>

                <div className="pricing-plan basic">
                    <h3>Basic Plan</h3>
                    <p className="price">$20<span>USD</span>/month</p>
                    <ul className="features">
                        <li><span className="checkmark"></span>Real Time Term Checking</li>
                        <li><span className="checkmark"></span>Tone Analysis</li>
                        <li><span className="checkmark"></span>Single User</li>
                    </ul>
                </div>

                <div className="pricing-plan professional">
                <h3>Professional Plan</h3>
                    <p className="price">$Custom Pricing</p>
                    <ul className="features">
                        <li><span className="checkmark"></span>Real Time Term Checking</li>
                        <li><span className="checkmark"></span>Tone Analysis</li>
                        <li><span className="checkmark"></span>Manage Users</li>
                        <li><span className="checkmark"></span>100+ Users</li>
                    </ul>
                </div>

                <div className="pricing-plan enterprise">
                    <h3>Enterprise Plan</h3>
                    <p className="price">$Custom Pricing</p>
                    <ul className="features">
                        <li><span className="checkmark"></span>Real Time Term Checking</li>
                        <li><span className="checkmark"></span>Tone Analysis</li>
                        <li><span className="checkmark"></span>Manage Users</li>
                        <li><span className="checkmark"></span>Custom Integrations</li>
                        <li><span className="checkmark"></span>Teams Dashboard</li>
                        <li><span className="checkmark"></span>Advanced Reporting</li>
                        <li><span className="checkmark"></span>Custom Users</li>
                    </ul>
                </div>
            </div>

            <h2 className="compare-plans">Compare Plans</h2>

            <div className="pricing-table">
                <div className="table-header">
                    <div className="table-column"></div>
                    <div className="table-column">Free Trial<br/>$0</div>
                    <div className="table-column">Basic Plan<br/>$20<span>USD</span>/month</div>
                    <div className="table-column">Professional Plan<br/>$Custom</div>
                    <div className="table-column">Enterprise Plan<br/>$Custom</div>
                </div>

                <div className="table-body">
                    <div className="feature-row">
                        <div className="feature-title">Real Time Term Checking</div>
                        <div className="feature-cell"><span className="check green"></span></div>
                        <div className="feature-cell"><span className="check blue"></span></div>
                        <div className="feature-cell"><span className="check orange"></span></div>
                        <div className="feature-cell"><span className="check cyan"></span></div>
                    </div>

                    <div className="feature-row">
                        <div className="feature-title">Tone Analysis</div>
                        <div className="feature-cell"><span className="check green"></span></div>
                        <div className="feature-cell"><span className="check blue"></span></div>
                        <div className="feature-cell"><span className="check orange"></span></div>
                        <div className="feature-cell"><span className="check cyan"></span></div>
                    </div>

                    <div className="feature-row">
                        <div className="feature-title">Teams Dashboard</div>
                        <div className="feature-cell dash">—</div>
                        <div className="feature-cell dash">—</div>
                        <div className="feature-cell dash">—</div>
                        <div className="feature-cell"><span className="check cyan"></span></div>
                    </div>

                    <div className="feature-row">
                        <div className="feature-title">Custom Integrations</div>
                        <div className="feature-cell dash">—</div>
                        <div className="feature-cell dash">—</div>
                        <div className="feature-cell dash">—</div>
                        <div className="feature-cell"><span className="check cyan"></span></div>
                    </div>

                    <div className="feature-row">
                        <div className="feature-title">Advanced Reporting</div>
                        <div className="feature-cell dash">—</div>
                        <div className="feature-cell dash">—</div>
                        <div className="feature-cell dash">—</div>
                        <div className="feature-cell"><span className="check cyan"></span></div>
                    </div>

                    <div className="feature-row">
                        <div className="feature-title">Users</div>
                        <div className="feature-cell">1</div>
                        <div className="feature-cell">1</div>
                        <div className="feature-cell">100+</div>
                        <div className="feature-cell">Custom Users</div>
                    </div>
                </div>
            </div>
            <div className="cta-section">
                <h2 className="cta-title">Get Started with VIZEdi</h2>
                <p className="cta-description">
                    Upskill your communication
                </p>
                <Link to="/login">
                    <button className="cta-button">Start Now</button>
                </Link>
                <p>
                    Looking for Enterprise?
                    <Link to="/customer-support" className="cta-link">
                        Contact customer support
                    </Link>
                </p>
            </div>
        </div>
    );
};

export default Pricing;
